import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Clock, Trophy, TrendingUp, Hash, Sparkles } from 'lucide-react';
import { SHEET_ANIMATION, BACKDROP_ANIMATION } from './sheetAnimationConfig';
/**
 * SortSheet - Bottom sheet for selecting sort order
 * Provides different sorting options for game lists
 */
const SortSheet = ({ isOpen, onClose, currentSort, onSortChange }) => {
  const sortOptions = [
    { id: 'smart', label: 'Smart', icon: Sparkles, description: 'Prioritize by league importance' },
    { id: 'time', label: 'Time', icon: Clock, description: 'Sort by kickoff time' },
    { id: 'league', label: 'League', icon: Trophy, description: 'Group by league' },
    { id: 'odds', label: 'Best Odds', icon: TrendingUp, description: 'Highest value bets first' },
    { id: 'popularity', label: 'Popular', icon: Hash, description: 'Most bet games first' }
  ];

  const handleSortSelect = (sortId) => {
    onSortChange(sortId);
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            {...BACKDROP_ANIMATION}
            className="fixed inset-0 bg-black/50 z-40"
            onClick={onClose}
          />
          
          {/* Sheet */}
          <motion.div
            {...SHEET_ANIMATION}
            className="fixed bottom-0 left-0 right-0 bg-gray-900 rounded-t-2xl z-50 max-h-[50vh] overflow-hidden"
          >
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-800">
              <h3 className="text-lg font-semibold text-white">Sort By</h3>
              <button
                onClick={onClose}
                className="p-1 rounded-lg hover:bg-gray-800 transition-colors"
              >
                <X className="w-5 h-5 text-gray-400" />
              </button>
            </div>
            
            {/* Sort Options */}
            <div className="p-2">
              {sortOptions.map((option) => {
                const Icon = option.icon;
                const isSelected = currentSort === option.id;
                
                return (
                  <button
                    key={option.id}
                    onClick={() => handleSortSelect(option.id)}
                    className={`
                      w-full flex items-center gap-3 p-3 rounded-lg transition-all
                      ${isSelected 
                        ? 'bg-emerald-500/20 border border-emerald-500/50' 
                        : 'hover:bg-gray-800/50'
                      }
                    `}
                  >
                    <div className={`
                      p-2 rounded-lg
                      ${isSelected ? 'bg-emerald-500/20' : 'bg-gray-800'}
                    `}>
                      <Icon className={`
                        w-4 h-4
                        ${isSelected ? 'text-emerald-400' : 'text-gray-400'}
                      `} />
                    </div>
                    
                    <div className="flex-1 text-left">
                      <div className={`
                        font-medium text-sm
                        ${isSelected ? 'text-emerald-400' : 'text-white'}
                      `}>
                        {option.label}
                      </div>
                      <div className="text-xs text-gray-500 mt-0.5">
                        {option.description}
                      </div>
                    </div>
                    
                    {isSelected && (
                      <div className="w-2 h-2 rounded-full bg-emerald-400" />
                    )}
                  </button>
                );
              })}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default SortSheet;